
import './Home.css'

const Home = () => {

 return (
  <div>
   <div className="pt-5 home">
    <h1 className="font-bolder text-warning">Prerna School of FineArts </h1>
    <h5>presents</h5>
    <h3>Virtual learning of Arts!</h3>
    <img src="https://static.vecteezy.com/system/resources/thumbnails/000/166/999/small/Tap_Dance.png" alt="" />
    <p className="m-5">Want to become a dancer or a singer but dont know where to start? In the present times as all our lives are doing a fine balancing act between a total Lockdown and a partial Lockdown, we are in constant uncertainty of Where and How to Enroll for certain classes or courses?! Should we wait for Onground Classes if the Lockdown lifts soon? Or will it be reinforced? So, should we sign up for Online Dance Classes instead? You have come the right place! Join our classes under the excellent guidance of out trained professionals. These classes are beginner friendly and you have no excuse not to begin!  </p>
    <hr />

   </div>

  </div>
 );
};

export default Home;